import styles from '../../styles/dynamic-form.module.sass'
import classNames from 'classnames'
import $ from 'jquery'
import React, { useEffect } from 'react'

declare global {
  interface Window {
    jQuery: any
    $: any
  }
}

if (typeof window !== 'undefined') {
  window.jQuery = $
  window.$ = $
  require('formBuilder/dist/form-render.min.js')
  require('jquery-ui-sortable')
}

type Props = {
  formData: string
  dynamicFormRef: React.MutableRefObject<any>
  isTextInputFloating?: boolean
}

export const FormBuilder = ({
  dynamicFormRef,
  formData,
  isTextInputFloating = false,
}: Props): JSX.Element => {
  const prepareFormRenderOpts = () => {
    let formDataObject = JSON.parse(formData)

    if (isTextInputFloating)
      formDataObject = formDataObject.map((formField) => {
        // Label styles are determined whether placeholder is visible or not
        // Since floating fields do not require a placeholder, keeping a white space
        if (formField.type === 'text') formField.placeholder = ' '
        return formField
      })

    // nonFileFields, use FileUploader for files
    const nonFileFields = formDataObject.filter((obj) => {
      return obj.type !== 'file' && !obj.label.toLowerCase().includes('school') // hide the dynamic school field
    })

    const formRenderOpts = {
      dataType: 'json',
      formData: JSON.stringify(nonFileFields),
    }

    return formRenderOpts
  }

  // If label are before input in DOM floating styles are not being applied
  // as successor selector is used to select label
  const placeLabelAfterTextInput = () => {
    const textInputContainers = document.querySelectorAll('.formbuilder-text')
    for (let index = 0; index < textInputContainers.length; index++) {
      textInputContainers[index].insertBefore(
        textInputContainers[index].childNodes[1],
        textInputContainers[index].firstChild
      )
    }
  }

  useEffect(() => {
    $(dynamicFormRef.current).formRender(prepareFormRenderOpts())
    if (isTextInputFloating) placeLabelAfterTextInput()

    const radios = document.querySelectorAll('.formbuilder-radio')
    radios &&
      radios.forEach((radio) => {
        radio.classList.add('flex', 'items-center', 'w-full')
      })
  }, [formData])

  return (
    <>
      <div
        id="fb-editor"
        className={classNames(`${styles['dynamic-form']}`, {
          'floating-input': isTextInputFloating,
        })}
        ref={dynamicFormRef}
      />
    </>
  )
}
